/** @file Compass picker of the Directions panel: one button per direction, showing its mode. */
import type { Dir, DirectionsDoc } from '@pose2d/format/types';
import type { Translate } from '@pose2d/i18n/types';
import { compassCells } from './compassCells';
import { directionModes } from './directionModes';

/** Props of Compass. */
export interface CompassProps {
  t: Translate;
  set: DirectionsDoc;
  selected: Dir | undefined;
  onSelect: (dir: Dir) => void;
}

/** Directions outside the set are disabled; direction codes are data (never translated). */
export function Compass({ t, set, selected, onSelect }: CompassProps) {
  return (
    <div className="rig-compass" role="group" aria-label={t('panels.directions.title')}>
      {compassCells(set).map(({ dir, allowed, mode }, i) => (dir === null ? <span key={i} /> : (
        <button key={dir} type="button" disabled={!allowed} aria-pressed={dir === selected} onClick={() => { onSelect(dir); }}>
          {allowed ? `${dir} · ${t(directionModes.label(mode ?? 'authored'))}` : dir}
        </button>
      )))}
    </div>
  );
}
